<template>
    <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id="veh_substitution"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#vehicleSubstitute"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Vehicle Substitution</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="vehicleSubstitute">
        <div class="row">
            <!-- Registration Location starts -->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0 mr-5">
          <float-label label="Registration Location*" :fixed="isFloat(vehicleSubstitutionData.rtaCity.value)">
            <select
              @search:blur="checkError(vehicleSubstitutionData.rtaCity,false)+setErrorClass(vehicleSubstitutionData.rtaCity,'rtaCity')"
              class="v-select-form form-control rtaCity"
              :class="{'bgc-error-field': vehicleSubstitutionData.rtaCity.errorText !== '',
               'remove_placeholder': vehicleSubstitutionData.rtaCity.value }"
              placeholder="Registration Location*"
              v-model="vehicleSubstitutionData.rtaCity.value"
              v-evolvews="vehicleSubstitutionData.rtaCity"
            >
            <option disabled selected value>Registration Location*</option>
            <option v-for="locationData in rtaLocationsData.rtaCityList" :key="locationData.rtaCode" :value="locationData.rtaCode">{{locationData.rtaCode}}-{{locationData.rtaCity}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="vehicleSubstitutionData.rtaCity.errorText!==''"
          >{{vehicleSubstitutionData.rtaCity.errorText}}</span>
        </div>
        <!-- Registration Location ends -->
        <!--Registration Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 col-6 p-0 mt-0 row">
          <div class="col-6">
            <RegNumSearch :registrationData="vehicleSubstitutionData.registrationNumber" @setvehicledetails="setRegData"></RegNumSearch>
          </div>
          <!-- <div class="loader-small mt-auto reg-loader" v-show="showRegLoader">
            <img src="@/assets/images/loader.gif" alt="done">
          </div> -->
        </div>
        <!--Registration Number ends-->
        </div>
    </div>
    </div>
</template>
<script>
import RegNumSearch from "@/../../shared_motor_component/RegNumSearch.vue";
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from 'vuejs-timepicker';
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
    name: "VehicleSubstitution",
    props: ["vehicleSubstitutionData","rtaLocationsData"],
    components: {
    FloatLabel,
    Datepicker,
    VueTimepicker,
    vSelect,
    RegNumSearch
  },
  setup(props, context) {
    let state = reactive({
        time:{
         hh : null, mm : null, A :null
      }
    });
    function setErrorClass(objToCheck,selector){
      if(objToCheck.value == "" || objToCheck.value == null){
        objToCheck.errorText = objToCheck.errorMessage;
        $("."+selector).find("input")[0].classList.add("v-select-error-field");
      }
      else{
        objToCheck.errorText = "";
        $("."+selector).find("input")[0].classList.toggle("v-select-error-field",false)
      }
    }
    function setRegData(e){
      setTimeout(function(){if(e.target.placeholder == "Vehicle Registration Number*") e.target.placeholder = ""},10) //placeholder fix for first box in reg no
      // let self=this;
      // props.vehicleData.yearOfManufacture.value = null;
      // props.vehicleData.dateOfRegistration.value = null;
      let regNum = props.vehicleSubstitutionData.registrationNumber;
      let regNumValue = regNum.values.join('');
      let regNumberCheckFlag = true;
      if(regNum.values.filter((val,index)=> index!= 2).every(val=> val!="") && regNum.errorText=='' && regNumValue!='NEW' ){
        // state.loaderEnabled = true;
        props.vehicleSubstitutionData.registrationNumber.value = regNum.values[2] ? regNum.values.join('-'): [regNum.values[0],regNum.values[1],regNum.values[3]].join('-');
        props.vehicleSubstitutionData.registrationNumber.errorText = ""
        //regNumberCheckFlag = true;
      }
    }
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;

    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.vehicleSubstitutionData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      setErrorClass,
      setRegData
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
}
</script>
<style scoped>
.v-select-error-field{
  color: #f77a7a !important
}
</style>

